import React, { useEffect, useState, useRef } from 'react';
import {
  Container,
  ContentContainer,
  Button,
  ButtonsContainer,
  IconPosition,
  DayContainer,
  ModalContainer,
  DayInputContainer,
  DatePickerContainer,
  CheckboxContainer,
  StyledInput,
  LoaderContainer,
  TimeText,
  AppointmentTitle,
  AppointmentContainer,
  Loader,
  AppointmentModalContainer,
  SelectContainer,
  SelectOption,
  InfoClientContainer,
} from './CalendarPage.styles';
import DatePicker from 'react-datepicker';
import Sidebar from '../../components/Sidebar/Sidebar';
import HamburgerSidebar from '../../components/HamburgerSidebar/HamburgerSidebar';
import Header from '../../components/Header/Header';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import { ReactComponent as Calendar } from '../../assets/icons/date.svg';
import { ReactComponent as ChevronLeft } from '../../assets/icons/left.svg';
import { ReactComponent as ChevronRight } from '../../assets/icons/right.svg';
import { ReactComponent as Info } from '../../assets/icons/info2.svg';

import ModalComponent from '../../components/Modal/ModalComponent';
import 'react-datepicker/dist/react-datepicker.css';
import { ReactComponent as Checkbox } from '../../assets/icons/checkbox.svg';
import { ReactComponent as Checkedbox } from '../../assets/icons/checkedBox.svg';
import { WORKING_HOURS, DAYS, SLOTS, SLOTS_TYPE, APPOINTMENT_TYPE } from '../../utils/constants';
import { useDispatch, useSelector } from 'react-redux';
import { getAllClients, getVendorWorkingHours, setWorkingHoursForVendor } from '../../store/slice/vendor/asyncThunks';
import { notifyError, notifyErrorLeft, notifyInfo } from '../../utils/notify';
import { selectAllClients, selectGetWorkingHoursPending, selectUserInfo } from '../../store/slice/vendor/slice';
import { Waveform } from '@uiball/loaders';
import moment from 'moment';
import {
  createAppointmentForClient,
  createAppointmentForLeadClient,
  createUnavailableAppointment,
  deleteAppointment,
  editAppointment,
  getAllVendorAppointments,
  getVendorOccupiedPeriod,
} from '../../store/slice/appointment/asyncThunks';
import {
  selectCreateAppointmentForClientPending,
  selectCreateUnavailableAppointmentPending,
  selectDeleteAppointmentPending,
  selectEditAppointmentPending,
  selectGetVendorOccupiedPeriodPending,
  selectVendorAppointments,
} from '../../store/slice/appointment/slice';
import Select from 'react-select';
import { getDay } from 'date-fns';
import {
  CurrentSlotContainer,
  SelectedSlotContainer,
  SelectedSlotForEditContainer,
  SlotContainer,
  SlotName,
  SlotsContainer,
  SlotsTitle,
} from '../ClientsPage/ClientDetails/ClientDetails.styles';

import { formatWorkingHours, timeFormatter } from '../../utils/utils';
import { useNavigate } from 'react-router-dom';

const CalendarPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const vendor = useSelector(selectUserInfo);
  const appointments = useSelector(selectVendorAppointments);
  const clients = useSelector(selectAllClients);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalWorkingHoursOpen, setIsModalWorkingHoursOpen] = useState(false);
  const [isModalUnavailableOpen, setIsModalUnavailableOpen] = useState(false);

  const [excludeTime, setExcludeTime] = useState([]);

  const [workingHours, setWorkingHours] = useState(WORKING_HOURS);
  const [weekDays, setWeekDays] = useState(DAYS);

  const getVendorOccupiedPeriodPending = useSelector(selectGetVendorOccupiedPeriodPending);
  const getWorkingHoursPending = useSelector(selectGetWorkingHoursPending);
  const createAppointmentForClientPending = useSelector(selectCreateAppointmentForClientPending);
  const editAppointmentPending = useSelector(selectEditAppointmentPending);

  const [selectedSlot, setSelectedSlot] = useState({});
  const [appointmentStartSlotSelected, setAppointmentStartSlotSelected] = useState({});
  const [appointmentEndSlotSelected, setAppointmentEndSlotSelected] = useState({});

  const [availableSlots, setSlots] = useState(SLOTS);
  const [show, setShow] = useState(false);

  const [filterDays, setFilterDays] = useState([]);
  const [appointmentDate, setAppointmentDate] = useState(new Date());
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [location, setLocation] = useState('');
  const [selectedClient, setSelectedClient] = useState(null);
  const [editAppointmentId, setEditAppointmentId] = useState(null);
  const [calendarClicked, setCalendarClicked] = useState(false);
  const [businessHours, setBusinessHours] = useState([]);
  const [selected, setSelected] = useState(APPOINTMENT_TYPE.APPOINTMENT);
  const [slotMin, setSlotMin] = useState('07:00:00');
  const [slotMax, setSlotMax] = useState('20:00:00');
  const createUnavailableAppointmentPending = useSelector(selectCreateUnavailableAppointmentPending);
  const deleteAppointmentPending = useSelector(selectDeleteAppointmentPending);

  const [leadClientName, setLeadClientName] = useState('');

  const datePickerRef = useRef(null);

  const handleIconClick = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };

  const calendarComponentRef = useRef(null);

  const [state, setState] = useState({
    events: [],
    title: '',
  });

  const handleWorkingHoursFormat = data => {
    let newObject = { ...data };

    Object.entries(data).forEach(([key, value]) => {
      if (value) {
        newObject[key] = moment(value, 'hh:mm a').toDate();
      } else {
        newObject[key] = value;
      }
    });
    return newObject;
  };

  useEffect(() => {
    dispatch(getAllVendorAppointments());
    dispatch(getVendorWorkingHours())
      .unwrap()
      .then(data => {
        setWorkingHours(handleWorkingHoursFormat(data.data.workingHours));
        setBusinessHours(formatWorkingHours(data.data.workingHours));
        handleDaysToFilter(data.data.workingHours);
      })
      .catch(err => {
        console.log(err);
      });
  }, [dispatch]);

  const updateTitle = newTitle => {
    setState(prevState => ({
      ...prevState,
      title: newTitle,
    }));
  };

  const handlePrevButtonClick = () => {
    const calendarApi = calendarComponentRef?.current?.getApi();
    calendarApi.prev();

    updateTitle(calendarApi?.view?.title);
  };

  const handleNextButtonClick = () => {
    const calendarApi = calendarComponentRef?.current?.getApi();
    calendarApi.next();

    updateTitle(calendarApi?.view?.title);
  };

  const openModal = () => {
    dispatch(getAllClients());
    // if (vendor.workingHours) {
    //   handleDaysToFilter(vendor.workingHours);
    // }
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setName('');
    setDescription('');
    setLocation('');
    setAppointmentDate(new Date());
    setSelectedClient(null);
    setSelectedSlot({});
    setSlots(SLOTS);
    setIsModalOpen(false);
    setShow(false);
    setSelected(APPOINTMENT_TYPE.APPOINTMENT);
    setLeadClientName('');
  };

  const handleSlots = date => {
    const day = DAYS[date.getDay()];
    const open = vendor.workingHours[day.id + '_1_open'];
    const close = vendor.workingHours[day.id + '_1_close'];
    const openHours = moment(open, 'hh:mm a').toDate().getHours();
    const closeHours = moment(close, 'hh:mm a').toDate().getHours();
    const newSlots = [...SLOTS];

    return newSlots.filter(slot => slot.value >= openHours && slot.value < closeHours);
  };

  const handleSelectSlot = slot => {
    if (selectedSlot.id === slot.id) {
      setSelectedSlot({});
    } else {
      setSelectedSlot(slot);
    }
  };

  const isFilterDay = date => {
    const day = getDay(date);
    if (filterDays.includes(day)) {
      return false;
    }
    return true;
  };

  const handleDaysToFilter = data => {
    let filterDays = [];
    let firstClockToShow = 0;
    let lastClockToShow = 0;

    for (const day of DAYS) {
      if (!data[day.id + '_1_open']) {
        filterDays.push(day.number);
      } else {
        const formattedTimeOpen = moment(data[day.id + '_1_open'], ['hh:mm:ss A']).format('hh:mm A');
        const formattedTimeClose = moment(data[day.id + '_1_close'], ['hh:mm:ss A']).format('hh:mm A');

        const hourValueOpen = SLOTS.find(slot => slot.title.toString() === formattedTimeOpen);
        const hourValueClose = SLOTS.find(slot => slot.title.toString() === formattedTimeClose);

        if (hourValueOpen && firstClockToShow < parseInt(hourValueOpen.value, 10)) {
          firstClockToShow = hourValueOpen.value;
        }
        if (hourValueClose && lastClockToShow < parseInt(hourValueClose.value, 10)) {
          lastClockToShow = hourValueClose.value;
        }
        setSlotMin(firstClockToShow + ':00:00');
        setSlotMax(lastClockToShow + ':00:00');
      }
    }
    setFilterDays(filterDays);
  };

  const handleSetDate = date => {
    const workingsSlots = handleSlots(date);
    setSelectedSlot({});
    setAppointmentStartSlotSelected({});
    setAppointmentDate(date);
    setShow(true);
    dispatch(getVendorOccupiedPeriod(date.getTime()))
      .unwrap()
      .then(data => {
        let newSlots = [...workingsSlots];
        for (const period of data.data) {
          if (period.type === SLOTS_TYPE.APPOINTMENT) {
            newSlots = newSlots.filter(slot => slot.value !== new Date(period.from).getHours().toString());
          } else {
            newSlots = newSlots.filter(
              slot => +slot.value < new Date(period.from).getHours() || +slot.value >= new Date(period.to).getHours(),
            );
          }
        }
        setSlots(newSlots);
        //setShow(true);
      })
      .catch(err => {
        console.log(err);
      });
  };

  const handleCreateAppointmentType = () => {
    if (selected === APPOINTMENT_TYPE.APPOINTMENT) {
      handleCreateAppointment();
    } else if (selected === APPOINTMENT_TYPE.LEAD) {
      handleCreateAppointmentForLeadClient();
    } else {
      handleCreateUnavailableAppointment();
    }
  };

  const handleCreateAppointment = () => {
    let newFrom = new Date(appointmentDate);
    newFrom.setHours(selectedSlot.value ? selectedSlot.value : appointmentStartSlotSelected.value);
    newFrom.setSeconds(0);
    newFrom.setMinutes(0);
    let newTo = new Date(newFrom);
    newTo.setHours(newTo.getHours() + 1);
    const sendData = {
      id: selectedClient.value,
      body: {
        name,
        description,
        location,
        date: appointmentDate.getTime(),
        from: newFrom.getTime(),
        to: newTo.getTime(),
      },
    };
    dispatch(createAppointmentForClient(sendData))
      .unwrap()
      .then(() => {
        closeModal();
        closeAppointmentModalWhenCalendarSelect();
        notifyInfo('Appointment created successfully');
      })
      .catch(err => {
        notifyErrorLeft(err.message);
      });
  };

  const handleCreateAppointmentForLeadClient = () => {
    let newFrom = new Date(appointmentDate);
    newFrom.setHours(selectedSlot.value ? selectedSlot.value : appointmentStartSlotSelected.value);
    newFrom.setSeconds(0);
    newFrom.setMinutes(0);
    let newTo = new Date(newFrom);
    newTo.setHours(newTo.getHours() + 1);
    const sendData = {
      name,
      description,
      location,
      date: appointmentDate.getTime(),
      from: newFrom.getTime(),
      to: newTo.getTime(),
      clientName: leadClientName,
    };
    dispatch(createAppointmentForLeadClient(sendData))
      .unwrap()
      .then(() => {
        closeModal();
        closeAppointmentModalWhenCalendarSelect();
        notifyInfo('Appointment created successfully');
      })
      .catch(err => {
        notifyErrorLeft(err.message);
      });
  };

  const openEditModal = event => {
    if (event.extendedProps.type === SLOTS_TYPE.APPOINTMENT) {
      if (event.extendedProps.clientId) {
        dispatch(getAllClients());
        setSelectedClient({ value: event.extendedProps.clientId, label: event.extendedProps.client });
      } else {
        setSelected(APPOINTMENT_TYPE.LEAD);
        setLeadClientName(event.extendedProps.client);
      }

      const found = SLOTS.find(element => element.value === event.start.getHours().toString());
      setEditAppointmentId(event._def.publicId);
      setName(event.title);
      setDescription(event.extendedProps.description);
      setLocation(event.extendedProps.location);
      setAppointmentDate(event.start);
      handleSetDate(event.start);
      setAppointmentStartSlotSelected(found);
      setIsModalOpen(true);
      setShow(true);
    }
  };

  const closeEditModal = () => {
    setName('');
    setDescription('');
    setLocation('');
    setAppointmentDate(new Date());
    setSelectedClient(null);
    setSelectedSlot({});
    setSlots(SLOTS);
    setIsModalOpen(false);
    setShow(false);
    setEditAppointmentId(null);
    setAppointmentStartSlotSelected({});
    setSelected(APPOINTMENT_TYPE.APPOINTMENT);
    setLeadClientName('');
  };

  const handleEditAppointment = () => {
    let newFrom = new Date(appointmentDate);
    newFrom.setHours(selectedSlot.value ? selectedSlot.value : appointmentStartSlotSelected.value);
    newFrom.setSeconds(0);
    newFrom.setMinutes(0);
    let newTo = new Date(newFrom);
    newTo.setHours(newTo.getHours() + 1);
    const sendData = {
      id: editAppointmentId,
      body: {
        name,
        description,
        location,
        ...(selectedClient && selectedClient.value && { userId: selectedClient.value }),
        ...(leadClientName && { clientName: leadClientName }),
        // userId: selectedClient.value,
        date: appointmentDate.getTime(),
        from: newFrom.getTime(),
        to: newTo.getTime(),
      },
    };
    dispatch(editAppointment(sendData))
      .unwrap()
      .then(() => {
        closeEditModal();
        notifyInfo('Appointment edited successfully');
      })
      .catch(err => {
        console.log(err);
        notifyErrorLeft(err.message);
      });
  };

  const openWorkingHoursModal = () => {
    if (vendor.workingHours) {
      setWorkingHours(handleWorkingHoursFormat(vendor.workingHours));
    }
    setIsModalWorkingHoursOpen(true);
  };

  const closeWorkingHoursModal = () => {
    setIsModalWorkingHoursOpen(false);
    if (vendor.workingHours) {
      setWorkingHours(handleWorkingHoursFormat(vendor.workingHours));
    } else {
      setWorkingHours(WORKING_HOURS);
    }
    setWeekDays(DAYS);
    setExcludeTime([]);
  };

  const setHour = (day, time, isOpen) => {
    let nameDay;
    if (isOpen) {
      let times = [];
      nameDay = day.id + '_1_open';
      for (let i = 1; i < time.getHours() + 1; i++) {
        times.push(new Date(0, 0, 0, i));
      }
      setExcludeTime(times);
      if (workingHours[day.id + '_1_close'] < time) {
        setWorkingHours(prev => {
          return { ...prev, [day.id + '_1_close']: '' };
        });
      }
    } else {
      nameDay = day.id + '_1_close';
    }
    setWorkingHours(prev => {
      return { ...prev, [nameDay]: time };
    });
  };

  const setExcludedTime = day => {
    const time = workingHours[day.id + '_1_open'];
    if (time) {
      let times = [];
      for (let i = 1; i < time.getHours() + 1; i++) {
        times.push(new Date(0, 0, 0, i));
      }
      setExcludeTime(times);
    }
  };

  const checkIsSetOpenAndClose = () => {
    let found = false;
    for (const day of DAYS) {
      if (!workingHours[day.id + '_1_open'] || !workingHours[day.id + '_1_close']) {
        if (!workingHours[day.id + '_1_open'] && !workingHours[day.id + '_1_close']) {
        } else {
          found = true;
          return found;
        }
      }
    }
    return found;
  };

  const checkIsCloseDisabled = day => {
    let openIsSet = true;
    if (!workingHours[day.id + '_1_open']) {
      openIsSet = false;
    }
    return openIsSet;
  };

  const onContinue = () => {
    let newObject = { ...workingHours };
    Object.entries(workingHours).forEach(([key, value]) => {
      if (value) {
        newObject[key] = value.toLocaleTimeString('en-US');
      } else {
        newObject[key] = value;
      }
    });
    dispatch(setWorkingHoursForVendor(newObject))
      .unwrap()
      .then(data => {
        setBusinessHours(formatWorkingHours(data.data.workingHours));
        setWorkingHours(handleWorkingHoursFormat(data.data.workingHours));
        handleDaysToFilter(data.data.workingHours);
        closeWorkingHoursModal();
        notifyInfo('Working hours set successfully');
      })
      .catch(err => {
        console.log(err);
        notifyErrorLeft(err.message);
      });
  };

  const onCheck = day => {
    setWeekDays(
      weekDays.map(d => {
        if (d.id === day.id) {
          setWorkingHours(prev => {
            return { ...prev, [day.id + '_1_open']: '', [day.id + '_1_close']: '' };
          });
          return { ...d, selected: !d.selected };
        } else {
          return d;
        }
      }),
    );
  };

  const openAppointmentModalWhenCalendarSelect = (start, end, date) => {
    dispatch(getAllClients());
    // if (vendor.workingHours) {
    //   handleDaysToFilter(vendor.workingHours);
    // }
    const found = SLOTS.find(element => element.value === start.toString());
    handleSetDate(date);
    setAppointmentStartSlotSelected(found);
    setCalendarClicked(true);
    setIsModalOpen(true);
    setShow(true);
  };
  const closeAppointmentModalWhenCalendarSelect = () => {
    setName('');
    setDescription('');
    setLocation('');
    setAppointmentDate(new Date());
    setSelectedClient(null);
    setSelectedSlot({});
    setAppointmentStartSlotSelected({});
    setAppointmentEndSlotSelected({});
    setSlots(SLOTS);
    setIsModalOpen(false);
    setShow(false);
    setCalendarClicked(false);
    setSelected(APPOINTMENT_TYPE.APPOINTMENT);
    setLeadClientName('');
  };

  const openUnavailableModal = (start, end, date) => {
    const foundStart = SLOTS.find(element => element.value === start.toString());
    const foundEnd = SLOTS.find(element => element.value === end.toString());
    handleSetDate(date);
    setName('Unavailable');
    setAppointmentStartSlotSelected(foundStart);
    setAppointmentEndSlotSelected(foundEnd);
    setCalendarClicked(true);
    setIsModalUnavailableOpen(true);
  };

  const closeUnavailableModal = () => {
    setName('');
    setDescription('');
    setAppointmentDate(new Date());
    setAppointmentStartSlotSelected({});
    setAppointmentEndSlotSelected({});
    setSlots(SLOTS);
    setIsModalUnavailableOpen(false);
    setCalendarClicked(false);
    setSelectedSlot({});
  };
  const handleSelectedDates = info => {
    const start = info.start.getHours();
    const end = info.end.getHours();

    if (info.start < new Date()) {
      notifyError(`Can't make a appointment for days gone by`);
      return;
    }
    if (end - start === 1) {
      openAppointmentModalWhenCalendarSelect(start, end, info.start);
    } else {
      openUnavailableModal(start, end, info.start);
    }
  };

  const handleCreateUnavailableAppointment = () => {
    let newFrom = new Date(appointmentDate);
    newFrom.setSeconds(0);
    newFrom.setMinutes(0);
    let newTo = new Date(newFrom);
    if (selected === APPOINTMENT_TYPE.UNAVAILABLE) {
      newFrom.setHours(selectedSlot.value ? selectedSlot.value : appointmentStartSlotSelected.value);
      newTo.setHours(newFrom.getHours() + 1);
    } else {
      newFrom.setHours(appointmentStartSlotSelected.value);
      const duration = appointmentEndSlotSelected.value - appointmentStartSlotSelected.value;
      newTo.setHours(newTo.getHours() + duration);
    }
    const sendData = {
      name,
      description,
      date: appointmentDate.getTime(),
      from: newFrom.getTime(),
      to: newTo.getTime(),
    };
    dispatch(createUnavailableAppointment(sendData))
      .unwrap()
      .then(() => {
        closeUnavailableModal();
        closeAppointmentModalWhenCalendarSelect();
        notifyInfo('Unavailable appointment created successfully');
      })
      .catch(err => {
        notifyErrorLeft(err.message);
      });
  };

  const [currentView, setCurrentView] = useState('timeGridWeek');

  const handleDateClick = () => {
    if (currentView === 'timeGridWeek') {
      calendarComponentRef?.current?.getApi().changeView('dayGridMonth');
      setCurrentView('dayGridMonth');
    } else {
      calendarComponentRef?.current?.getApi().changeView('timeGridWeek');
      setCurrentView('timeGridWeek');
    }
  };

  useEffect(() => {
    const calendarApi = calendarComponentRef?.current?.getApi();
    if (calendarApi) {
      updateTitle(calendarApi?.view?.title);
    }

    return () => {};
  }, [currentView]);

  const handleDeleteAppointment = id => {
    dispatch(deleteAppointment({ id }))
      .unwrap()
      .then(() => {
        closeEditModal();
        setEditAppointmentId(null);
        notifyInfo('Successfully deleted appointment');

        try {
          calendarComponentRef?.current?.getApi().getEventById(id).remove();
          calendarComponentRef?.current?.getApi().refetchEvents();
        } catch (err) {
          console.log(err);
        }
      })
      .catch(err => {
        console.log(err);
        setEditAppointmentId(null);
        notifyErrorLeft(err.message);
      });
  };

  const CalendarButtons = () => {
    return (
      <ButtonsContainer>
        <Button onClick={handlePrevButtonClick}>
          <ChevronLeft />
        </Button>
        <Button onClick={handleDateClick}>{state.title}</Button>
        <Button onClick={handleNextButtonClick}>
          <ChevronRight />
        </Button>
      </ButtonsContainer>
    );
  };

  const renderEventContent = event => {
    return (
      <AppointmentContainer>
        <TimeText>{event.timeText}</TimeText>
        <AppointmentTitle>
          {event.event._def.extendedProps.type === 'appointment' ? 'Appointment' : event.event._def.title}
        </AppointmentTitle>
        {event.event?._def?.extendedProps?.type !== APPOINTMENT_TYPE.UNAVAILABLE && (
          <AppointmentTitle>{event.event._def.extendedProps.client}</AppointmentTitle>
        )}
      </AppointmentContainer>
    );
  };

  const isNotFilledForClient = () =>
    createAppointmentForClientPending ||
    editAppointmentPending ||
    createUnavailableAppointmentPending ||
    (selected === APPOINTMENT_TYPE.APPOINTMENT && !selectedClient) ||
    (selected === APPOINTMENT_TYPE.LEAD && !leadClientName) ||
    !name ||
    (!Object.keys(selectedSlot).length && !Object.keys(appointmentStartSlotSelected).length) ||
    !appointmentDate;

  const isNotFilledForUnavailable = () =>
    !Object.keys(selectedSlot).length && !Object.keys(appointmentStartSlotSelected).length;

  const onClientDetailsOpen = id => {
    closeEditModal();
    navigate({
      pathname: '/clients',
      search: `?screen=details&id=${id}&tab=contracts`,
    });
  };

  return (
    <Container>
      <Sidebar />
      <HamburgerSidebar />
      <ContentContainer>
        <Header
          onButtonClick={openModal}
          title={'Calendar'}
          buttonAdd={true}
          buttonText={'New Appointment'}
          secondButtonAdd={true}
          secondButtonText={'Edit Working Hours'}
          onSecondButtonClick={openWorkingHoursModal}
          calendarButtons={<CalendarButtons />}
        />
        {!getWorkingHoursPending ? (
          <FullCalendar
            slotLabelFormat={{
              hour: '2-digit',
              minute: '2-digit',
              omitZeroMinute: false,
              meridiem: true,
              hour12: true,
            }}
            expandRows
            ref={calendarComponentRef}
            initialView="timeGridWeek"
            dayHeaderClassNames={currentView === 'timeGridWeek' && 'fc-header'}
            dayHeaderContent={
              currentView === 'timeGridWeek'
                ? arg => {
                    return new Intl.DateTimeFormat('en-US', {
                      weekday: 'short',
                      month: 'long',
                      day: 'numeric',
                    }).format(arg.date);
                  }
                : false
            }
            allDaySlot={false}
            allDayText=""
            displayEventTime={true}
            headerToolbar={
              currentView === 'timeGridWeek'
                ? {
                    left: '',
                    center: '',
                    right: '',
                  }
                : false
            }
            slotDuration="01:00:00"
            slotLabelInterval={60}
            selectable={true}
            selectMirror
            plugins={[dayGridPlugin, interactionPlugin, timeGridPlugin]}
            eventClick={event => {
              openEditModal(event.event);
            }}
            select={handleSelectedDates}
            events={appointments.data}
            eventContent={renderEventContent}
            selectConstraint={businessHours}
            slotMinTime={slotMin}
            slotMaxTime={slotMax}
            selectOverlap={false}
            businessHours={businessHours}
            nowIndicator
            hiddenDays={filterDays}
            eventTimeFormat={{ hour: 'numeric', minute: '2-digit', meridiem: 'short' }}
          />
        ) : (
          <Loader>
            <Waveform size={64} lineWeight={6} speed={1} color="#000" />
          </Loader>
        )}
      </ContentContainer>

      <ModalComponent
        loading={createAppointmentForClientPending || editAppointmentPending || createUnavailableAppointmentPending}
        isOpen={isModalOpen}
        onClose={
          calendarClicked ? closeAppointmentModalWhenCalendarSelect : editAppointmentId ? closeEditModal : closeModal
        }
        title={editAppointmentId ? 'Edit Appointment' : 'New Appointment'}
        rightButtonTitle={editAppointmentId && 'Save'}
        onCreate={editAppointmentId ? handleEditAppointment : handleCreateAppointmentType}
        createDisabled={
          ((selected === APPOINTMENT_TYPE.APPOINTMENT || selected === APPOINTMENT_TYPE.LEAD) &&
            isNotFilledForClient()) ||
          (selected === APPOINTMENT_TYPE.UNAVAILABLE && isNotFilledForUnavailable())
        }
        deleteIcon={editAppointmentId}
        appointment
        deleteLoading={deleteAppointmentPending}
        onClickDelete={() => {
          handleDeleteAppointment(editAppointmentId);
        }}>
        <AppointmentModalContainer>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 20, padding: 10 }}>
            {!editAppointmentId && (
              <SelectContainer>
                <SelectOption
                  $selected={selected === APPOINTMENT_TYPE.APPOINTMENT}
                  onClick={() => {
                    setSelected(APPOINTMENT_TYPE.APPOINTMENT);
                    setName('');
                    setSelectedClient(null);
                    setLeadClientName('');
                  }}>
                  Appointment
                </SelectOption>
                <SelectOption
                  $selected={selected === APPOINTMENT_TYPE.LEAD}
                  onClick={() => {
                    setSelected(APPOINTMENT_TYPE.LEAD);
                    setName('');
                    setSelectedClient(null);
                    setLeadClientName('');
                  }}>
                  Lead
                </SelectOption>
                <SelectOption
                  $selected={selected === APPOINTMENT_TYPE.UNAVAILABLE}
                  onClick={() => {
                    setSelected(APPOINTMENT_TYPE.UNAVAILABLE);
                    setName('Unavailable');
                    setSelectedClient(null);
                    setLeadClientName('');
                  }}>
                  Unavailable
                </SelectOption>
              </SelectContainer>
            )}
            <StyledInput
              placeholder="Appointment type"
              onChange={n => setName(n.target.value)}
              value={name}
              disabled={selected === APPOINTMENT_TYPE.UNAVAILABLE}
            />
            {(selected === APPOINTMENT_TYPE.APPOINTMENT || selected === APPOINTMENT_TYPE.LEAD) && (
              <>
                {selected === APPOINTMENT_TYPE.APPOINTMENT ? (
                  <InfoClientContainer>
                    <Select
                      theme={theme => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: '#f1e4df',
                          primary: '#f1e4df',
                          primary75: '#f1e4df',
                          primary50: '#f1e4df',
                        },
                      })}
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          width: editAppointmentId ? '95%' : '100%',
                          boxShadow: state.isFocused ? 'none' : 'none',
                          borderColor: state.isFocused ? '#f1e4df !important' : 'rgba(0,0,0,0.15)',
                        }),

                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isFocused && '#F1E4DF',
                          color: 'black',
                        }),
                      }}
                      options={clients.data}
                      isClearable
                      placeholder={'Client'}
                      onChange={c => setSelectedClient(c)}
                      value={selectedClient ? selectedClient : ''}
                      isDisabled={editAppointmentId}
                    />
                    {editAppointmentId && (
                      <Info
                        style={{ position: 'absolute', top: 8, right: 0 }}
                        onClick={() => {
                          onClientDetailsOpen(selectedClient.value);
                        }}
                      />
                    )}
                  </InfoClientContainer>
                ) : (
                  selected === APPOINTMENT_TYPE.LEAD && (
                    <StyledInput
                      placeholder="Client"
                      onChange={n => {
                        setLeadClientName(n.target.value);
                        setSelectedClient(null);
                      }}
                      value={leadClientName}
                    />
                  )
                )}
                <StyledInput
                  placeholder="Location"
                  optional={true}
                  onChange={n => setLocation(n.target.value)}
                  value={location}
                />
              </>
            )}
            <StyledInput
              placeholder="Details"
              optional={true}
              value={description}
              onChange={n => setDescription(n.target.value)}
            />
            <div className="border-bottom">
              <DatePicker
                placeholderText="Date & Time"
                dateFormat="MMMM d, yyyy"
                className="date-picker"
                selected={appointmentDate}
                calendarClassName="scale"
                onChange={date => handleSetDate(date)}
                minDate={new Date()}
                filterDate={isFilterDay}
                ref={datePickerRef}
              />
              <IconPosition onClick={handleIconClick}>
                <Calendar />
              </IconPosition>
            </div>
            {(editAppointmentId || calendarClicked) &&
              !Object.keys(selectedSlot).length &&
              Object.keys(appointmentStartSlotSelected).length > 0 && (
                <CurrentSlotContainer>
                  <SlotName>Appointment Start:</SlotName>
                  <SelectedSlotForEditContainer>
                    <SlotName>{appointmentStartSlotSelected.title}</SlotName>
                  </SelectedSlotForEditContainer>
                </CurrentSlotContainer>
              )}

            <>
              <SlotsTitle>Available Slots</SlotsTitle>
              {show ? (
                <>
                  {!getVendorOccupiedPeriodPending ? (
                    <>
                      <SlotsContainer>
                        {availableSlots.map(slot => (
                          <div key={slot.id}>
                            {slot.id === selectedSlot.id ? (
                              <SelectedSlotContainer key={slot.id} onClick={() => handleSelectSlot(slot)}>
                                <SlotName>{slot.title}</SlotName>
                              </SelectedSlotContainer>
                            ) : (
                              <SlotContainer onClick={() => handleSelectSlot(slot)}>
                                <SlotName>{slot.title}</SlotName>
                              </SlotContainer>
                            )}
                          </div>
                        ))}
                      </SlotsContainer>
                    </>
                  ) : (
                    <LoaderContainer>
                      <Waveform size={26} lineWeight={3.5} speed={1} color="black" />
                    </LoaderContainer>
                  )}
                </>
              ) : (
                <SlotName>Select date to see available time slots</SlotName>
              )}
            </>
          </div>
        </AppointmentModalContainer>
      </ModalComponent>

      <ModalComponent
        isOpen={isModalWorkingHoursOpen}
        onClose={closeWorkingHoursModal}
        onCreate={onContinue}
        createDisabled={checkIsSetOpenAndClose()}
        rightButtonTitle={'Save'}
        title={'Set Up Working Hours'}>
        <ModalContainer>
          {weekDays.map(day => {
            return !day.selected ? (
              <DayContainer key={day.id}>
                <CheckboxContainer>
                  <Checkbox width={24} height={24} onClick={() => onCheck(day)} />
                </CheckboxContainer>

                <DayInputContainer>
                  <StyledInput placeholder="Name" value={day.name} disabled />
                  <StyledInput placeholder="Closed" value={'Closed'} disabled />
                </DayInputContainer>
              </DayContainer>
            ) : (
              <DayContainer key={day.id}>
                <CheckboxContainer>
                  <Checkedbox width={24} height={24} stroke="#BC826C" onClick={() => onCheck(day)} />
                </CheckboxContainer>

                <DayInputContainer>
                  <StyledInput placeholder="Name" value={day.name} disabled={true} />
                </DayInputContainer>
                <DatePickerContainer>
                  <DatePicker
                    placeholderText="Date & Time"
                    className="date-picker"
                    dateFormat="hh:mm a"
                    selected={workingHours[day.id + '_1_open']}
                    calendarClassName="scale"
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={60}
                    onChange={date => setHour(day, date, true)}
                  />
                </DatePickerContainer>

                <DatePickerContainer>
                  <DatePicker
                    placeholderText="Date & Time"
                    className="date-picker"
                    dateFormat="hh:mm a"
                    selected={workingHours[day.id + '_1_close']}
                    calendarClassName="scale"
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={60}
                    excludeTimes={excludeTime}
                    onChange={date => setHour(day, date, false)}
                    disabled={!checkIsCloseDisabled(day)}
                    onCalendarOpen={() => setExcludedTime(day)}
                  />
                </DatePickerContainer>
              </DayContainer>
            );
          })}
        </ModalContainer>
      </ModalComponent>

      <ModalComponent
        isOpen={isModalUnavailableOpen}
        onClose={closeUnavailableModal}
        title={'Create Unavailable Time'}
        onCreate={handleCreateUnavailableAppointment}
        loading={createUnavailableAppointmentPending}
        createDisabled={createUnavailableAppointmentPending}
        cancelDisabled={createUnavailableAppointmentPending}>
        <StyledInput placeholder="Name" value={name} disabled />

        <StyledInput
          placeholder="Details"
          optional={true}
          value={description}
          onChange={n => setDescription(n.target.value)}
        />
        <div className="border-bottom">
          <DatePicker
            placeholderText="Date & Time"
            dateFormat="MMMM d, yyyy"
            className="date-picker"
            selected={appointmentDate}
            calendarClassName="scale"
            onChange={date => handleSetDate(date)}
            minDate={new Date()}
            filterDate={isFilterDay}
            disabled
            ref={datePickerRef}
          />
          <IconPosition onClick={handleIconClick}>
            <Calendar />
          </IconPosition>
        </div>

        {calendarClicked && (
          <CurrentSlotContainer>
            <SlotName> Start:</SlotName>
            <SelectedSlotForEditContainer key={appointmentStartSlotSelected.id}>
              <SlotName>{appointmentStartSlotSelected.title}</SlotName>
            </SelectedSlotForEditContainer>
            <SlotName> End:</SlotName>
            <SelectedSlotForEditContainer key={appointmentEndSlotSelected.id}>
              <SlotName>{appointmentEndSlotSelected.title}</SlotName>
            </SelectedSlotForEditContainer>
          </CurrentSlotContainer>
        )}
      </ModalComponent>
    </Container>
  );
};

export default CalendarPage;
